import React, {FC} from 'react';
import {productPlaceholder} from '@/lib/placeholders';
import {VideoSlide} from '@/_application/core/components/ui/thumb-carousel/slide-content/video-slide';
import {ImageSlide} from '@/_application/core/components/ui/thumb-carousel/slide-content/image-slide';
import {getAltText, isProductImage} from '@/_application/helpers/media';
import {getCdnImageUrl} from '@/_application/helpers/cdn-image-resize';
import {Image} from '@/_application/core/components/ui/image';
import {ChevronButton} from '@/_application/core/components/ui/thumb-carousel/chevron-button';
import {ThumbnailsProps} from './thumbnails.types';
import styles from './thumbnails.module.css';
import {useThumbnailCarousel} from '@/_application/core/hooks/use-thumbnail-carousel';

export const Thumbnails: FC<ThumbnailsProps> = ({badgeImage, gallery, product, currentSlide, onThumbClick}) => {
    const {containerRef, prevRef, nextRef, showArrows, setThumbRef, handleThumbClick} = useThumbnailCarousel({
        gallery,
        currentSlide,
        onThumbClick,
    });

    return (
        <div className={styles.wrapper}>
            <div ref={containerRef} className={styles.container}>
                {gallery?.map((item, index) => {
                    const isActive = currentSlide === index;

                    return (
                        <div
                            key={`thumb-${index}`}
                            ref={setThumbRef(index)}
                            onClick={() => handleThumbClick(index)}
                            className={`${styles.thumb} ${isActive ? styles.thumbActive : ''}`}>
                            {isProductImage(item) ? (
                                <ImageSlide
                                    variant="thumbnail"
                                    imageSrc={{
                                        url: getCdnImageUrl(item?.url ?? productPlaceholder, 'thumbnail'),
                                        alt: getAltText(item, index, product),
                                    }}
                                />
                            ) : (
                                <VideoSlide
                                    variant="thumbnail"
                                    imageSrc={{
                                        url: item.url ?? productPlaceholder,
                                        alt: getAltText(item, index, product),
                                    }}
                                />
                            )}

                            {badgeImage && index === 0 && (
                                <span className={styles.badge}>
                                    <Image
                                        className={styles.badgeImage}
                                        src={badgeImage}
                                        width={50}
                                        height={20}
                                        alt="badge"
                                    />
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>

            {showArrows && (
                <ChevronButton
                    prevRef={prevRef}
                    nextRef={nextRef}
                    classNamePrev={styles.prevArrow}
                    classNameNext={styles.nextArrow}
                />
            )}
        </div>
    );
};
